import { GenderType, GymApparatus, ScoreType } from '../../../../models';
import { ncaaHeadCoaches } from '../../../../data/coaches';

export const coachData = {
  ...ncaaHeadCoaches,
  C1: {
    name: 'Head Coach',
  },
  C2: {
    name: 'Head Coach',
  },
};

export const sanitizeAttendanceValue = (value) => {
  if (value === undefined || value === null) {
    return '';
  }

  return String(value).replace(/[^\d]/g, '');
};

export const formatAttendanceValue = (value) => {
  const sanitizedValue = sanitizeAttendanceValue(value);
  return sanitizedValue ? Number(sanitizedValue).toLocaleString() : '';
};

export function getJudgesByApparatus(session) {
  if (!session) return {};

  const judgesByApparatus =
    session.gender === GenderType.FEMALE
      ? {
          [GymApparatus.VT]: { headJudge: null, rest: {} },
          [GymApparatus.UB]: { headJudge: null, rest: {} },
          [GymApparatus.BB]: { headJudge: null, rest: {} },
          [GymApparatus.FX]: { headJudge: null, rest: {} },
        }
      : {
          [GymApparatus.FX]: { headJudge: null, rest: {} },
          [GymApparatus.PH]: { headJudge: null, rest: {} },
          [GymApparatus.SR]: { headJudge: null, rest: {} },
          [GymApparatus.VT]: { headJudge: null, rest: {} },
          [GymApparatus.PB]: { headJudge: null, rest: {} },
          [GymApparatus.HB]: { headJudge: null, rest: {} },
        };

  const headJudgeScoreType =
    session.gender === GenderType.FEMALE ? ScoreType.J1 : ScoreType.D;

  // Judge configuration
  session?.rotations?.items?.forEach((rotation) => {
    if (!rotation._deleted) {
      rotation?.stages?.items?.forEach((stage) => {
        if (!stage._deleted) {
          const judgesForStage = judgesByApparatus[stage.apparatus];
          stage?.judges?.items?.forEach((stageJudge) => {
            if (!stageJudge._deleted) {
              const thisJudgeId = stageJudge.sessionJudgeAssignment?.judge?.id;
              if (!thisJudgeId) {
                // Skip judges without valid assignment
                return;
              }
              if (stageJudge.scoreTypes.indexOf(headJudgeScoreType) !== -1) {
                if (!judgesForStage.headJudge) {
                  judgesForStage.headJudge = stageJudge;
                } else if (
                  judgesForStage.headJudge.sessionJudgeAssignment?.judge?.id !==
                    thisJudgeId &&
                  !judgesForStage.rest[thisJudgeId]
                ) {
                  judgesForStage.rest[thisJudgeId] = stageJudge;
                }
              } else if (!judgesForStage.rest[thisJudgeId]) {
                judgesForStage.rest[thisJudgeId] = stageJudge;
              }
            }
          });
        }
      });
    }
  });

  return judgesByApparatus;
}

export const displayedScoreTypes = [
  ScoreType.D,
  ScoreType.D1,
  ScoreType.D2,
  ScoreType.E,
  ScoreType.E1,
  ScoreType.E2,
  ScoreType.E3,
  ScoreType.E4,
  ScoreType.E5,
  ScoreType.E6,
];

export function getJudgeDisplayContext(
  stageJudge,
  gender,
  parentheses = true,
  abbreviated = false
) {
  let result = '';

  if (!stageJudge || Object.keys(stageJudge).length === 0) {
    return result;
  }

  if (gender === GenderType.FEMALE) {
    const judge = stageJudge.sessionJudgeAssignment?.judge;
    if (judge?.womensBrevet) {
      result = abbreviated ? 'B' : 'Brevet';
    } else if (judge?.womensNational) {
      result = abbreviated ? 'N' : 'National';
    } else if (judge?.womensLevel10) {
      result = abbreviated ? 'L10' : 'Level 10';
    }
  } else {
    result =
      (stageJudge?.scoreTypes &&
        `${stageJudge.scoreTypes
          .filter((scoreType) => displayedScoreTypes.indexOf(scoreType) !== -1)
          .join(', ')}`) ||
      '';
  }

  if (result !== '' && parentheses) {
    result = `(${result})`;
  }

  return result;
}
